<div class="loader-container">
  <mat-spinner diameter="50"></mat-spinner>
  <span *ngIf="loadingText" class="loading-text" [transloco]="loadingText">Loading...</span>
</div>
